<template>
  <div>
    <div class="card card-body p-0" style="border-radius: 10px;">
      <terms-table :terms="terms" :totalPages="totalPages" :page="page" @setPage="setPage" :setSkeletonLoader="displayLoader"></terms-table>
    </div>
  </div>
</template>

<script>

  import helpers from '@/helpers.js';
  import termsTable from './terms_table';

  export default {
    components: {
      termsTable,
    },


    data: function () {
      return {
        page: 0,
        fullPage: '',
        displayLoader: true,
      }
    },


    computed: {
      terms: function () {
        return this.$store.getters['termsandconditions/terms'];
      },
      totalPages: function () {
        return this.$store.getters['termsandconditions/totalPages'];
      }
    },


    created: function () {
      this.page = helpers.getPageQuery();
    },


    watch: {
      page: function (val) {
        this.setSkeletonLoader(true);
        this.$store.dispatch('termsandconditions/getAllTerms', val)
        .then(()=>{
          setTimeout(() => {
            this.setSkeletonLoader(false);
          },1000);
        });
        // setTimeout(() => {
        // }, 2000)
      }
    },


    methods: {
      setPage(page) {
        this.page = page;
        this.$router.push('term&conditions?page=' + page);
      },
      setSkeletonLoader(val){
        this.displayLoader = val;
        
      },
    }
  }
</script>
<style>
  .custom {
    position: absolute;
    z-index: 999;
    top: 246px;
    left: 40%;
    opacity: 0.0.5;
  }
</style>